export const assessmentTemplate = [
  {
    _id: "careFirstWeight",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "2",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "rLundIII",
      createdDate: "2023-12-21T00:00:00Z",
      modifiedBy: "rLundIII",
      modifiedDate: "2024-04-24T00:00:00Z",
      isActive: true,
    },
    omniData: {
      omniType: "careFirstWeight",
      omniTypeVersion: 3,
      title: "CareFirst Weight Loss",
      purpose: "Pre-screen specific info for weight related treatments",
      description:
        "The information you provide will be reviewed by Dr. Doodnauth and the CareFirst staff. They will contact you to discuss an appropriate weight loss program and answer any questions you may have.",
      duration: "Less than 2 minutes",
      directions: "Follow the onscreen instructions after you begin.",
      attribution: "",
      validated: "true",
      selfAssessment: false,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "cf1",
          shortTitle: "subjectWeight",
          numberText: "1",
          text: "What is {subject name's/your} weight (in pounds)?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "weight",
          answerOptions: [
            {
              value: "",
              text: "Weight",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "cf2",
          shortTitle: "subjectHeight",
          numberText: "2",
          text: "What is {subject name's/your} height (in feet and inches)?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "height",
          answerOptions: [
            {
              value: "",
              text: "Height",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },

        {
          omniID: "cf3",
          shortTitle: "subjectThyroidCancer",
          numberText: "3",
          text: "{has/have} {subject name/you} ever been diagnosed with a thyroid mass or thyroid cancer?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "cf4",
          shortTitle: "subjectTakesSemaglutide",
          numberText: "4",
          text: "{has/have} {subject name/you} ever taken a semaglutide (Wegovy, Ozempic) for weight loss and/or diabetes?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "cf5",
          shortTitle: "subjectHasHighBloodpressue",
          numberText: "5",
          text: "{does/do} {subject name/you} have high blood pressure?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "cf6",
          shortTitle: "subjectHasTypeTwoDiabetes",
          numberText: "6",
          text: "{does/do} {subject name/you} have type 2 diabetes?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "cf7",
          shortTitle: "subjectHasHighCholesterol",
          numberText: "7",
          text: "{does/do} {subject name/you} have high cholesterol?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },

        {
          omniID: "cf8",
          shortTitle: "subjectDateOfBirth",
          numberText: "8",
          text: "What is {subject name's/your} date of birth?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "date",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "",
              text: "Date of Birth",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "cf9",
          shortTitle: "subjectGiveEmergencyContact",
          numberText: "9",
          text: "Would you like to give us information about {his/her/their/your} emergency contact?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "cf10",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "cf11",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "cf11",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "cf10",
          shortTitle: "subjectCareGiver",
          numberText: "10",
          text: "Who is {his/her/their/your} emergency contact?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "caregiver",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "",
              text: "",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "cf11",
          shortTitle: "subjectRace",
          numberText: "11",
          text: "Which of the following options best describes {his/her/their/your} race?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "americanindianalaskanative",
              text: "American Indian/Alaska Native",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "asian",
              text: "Asian",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "blackafricanamerican",
              text: "Black or African American",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "nativehawaiianotherpacificislander",
              text: "Native Hawaiian or other Pacific Islander",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "white",
              text: "White",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "biracialmultiracial",
              text: "Biracial or Multiracial",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "prefernottosay",
              text: "Prefer not to say",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "cf12",
          shortTitle: "subjectEthnicity",
          numberText: "12",
          text: "{is/are} {subject name/you} of Hispanic, Latino, or of Spanish origin?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "mexicanchicano",
              text: "Mexican, Mexican Am., or Chicano",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "puertorican",
              text: "Puerto Rican",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "cuban",
              text: "Cuban",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "other",
              text: "Other",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "false",
              text: "Non-Hispanic",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "prefernottosay",
              text: "Prefer not to say",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },

        {
          omniID: "cf13",
          shortTitle: "subjectKnownConditions", //find!ak
          numberText: "13",
          text: "{has/have} {subject name/you} been diagnosed with any of the following?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "pancreatitis",
              text: "Pancreatitis",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "kidneyRenal",
              text: "Kidney/Renal Disease",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "gallbladder",
              text: "Gallbladder Disease",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "hypoglycemia",
              text: "Hypoglycemia",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: true,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
              isExclusive: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: { finalResult: null },
    },
  },
];
export const assessmentScoring = [
  {
    typeID: "careFirstWeightLoss",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 5,
        formula: null,
        questions: [],
      },
    ],
  },
];
